import { Link } from 'react-router-dom';
import { TableCell, TableRow } from '@/components/ui/table';
import { OpportunityItemList } from '@/features/opportunities/types';
import { cn } from '@/utils/styles';
import { flexRender, Row } from '@tanstack/react-table';
import { Route } from '@/constants';

function getOpportunityLinkProps(row: OpportunityItemList) {
  const enabled = row.status.name !== 'closed';
  const href = enabled ? Route.Opportunity.replace(':opportunityId', row.id) : '';
  return { enabled, href };
}

export function OpportunityRow({ row, isPremium }: { row: Row<OpportunityItemList>; isPremium: any }) {
  const { enabled, href } = getOpportunityLinkProps(row.original);

  const cells = row.getVisibleCells().map((cell) => {
    const disableRowLink = (cell.column.columnDef as any)?.meta?.disableRowLink;
    const content = flexRender(cell.column.columnDef.cell, cell.getContext());

    return (
      <TableCell key={cell.id} className={cn('truncate px-0 py-0', !enabled && 'text-neutral-500')}>
        {enabled && !disableRowLink ? (
          <Link
            to={href}
            className={cn('block h-full w-full px-2 py-3')}
            aria-label={`Open opportunity ${String(row.getValue('name') ?? '')}`}
          >
            {content}
          </Link>
        ) : (
          <div className="px-2 py-3">{content}</div>
        )}
      </TableCell>
    );
  });

  return (
    <TableRow
      key={row.id}
      data-state={row.getIsSelected() && 'selected'}
      className={cn(
        isPremium && 'cursor-pointer border-y-1 border-neutral-50 hover:bg-gray-200/50',
        !enabled ? 'pointer-events-none bg-neutral-100' : 'bg-base-white'
      )}
    >
      {cells}
    </TableRow>
  );
}
